module.exports = __webpack_public_path__ + "static/img/m_role.274c7ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/cz/m_role.png
// module id = qvjb
// module chunks = 7